// Strip tool call result JSON blocks and artifacts that leak into streamed text
export const stripToolResults = (text: string): string => {
  return text
    // Remove JSON objects with suggestionId on their own line (tool call results)
    .replace(/^.*\{"success"\s*:\s*true\s*,\s*"suggestionId".*\}.*$/gm, '')
    // Remove any line that is just a JSON object (generic tool results)
    .replace(/^\s*\{[^{}]*"success"\s*:\s*(true|false)[^{}]*\}\s*$/gm, '')
    // Remove standalone "QAgent" labels that precede tool results
    .replace(/^\s*QAgent\s*$/gm, '')
    // Remove standalone "Copy" labels (UI artifacts)
    .replace(/^\s*Copy\s*$/gm, '')
    // Remove empty blockquote lines (> with nothing after)
    .replace(/^\s*>\s*$/gm, '')
    // Remove internal [[pattern:…]] markers (read by the backend, not for users)
    .replace(/[ \t]*\[\[pattern:[a-z0-9_]*\]\][ \t]*/gi, '')
    // ...and a marker still arriving while the reply streams
    .replace(/[ \t]*\[\[?(p(a(t(t(e(r(n(:[a-z0-9_]*\]?)?)?)?)?)?)?)?)?$/i, '')
    // Remove lines with only XML/JSX-like fragment tags (</>, <>, etc.)
    .replace(/^\s*<\s*\/?\s*>\s*$/gm, '')
    // Remove lines that are just angle brackets or closing tags with no content
    .replace(/^\s*<\/?\w*\/?>\s*$/gm, '')
    // Collapse multiple blank lines into at most two
    .replace(/\n{3,}/g, '\n\n')
    .trim();
};
